// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyBvFonJniQrAO5FmVTdBAfIwi30v2LczkU",
  authDomain: "milan-kalyan-results.firebaseapp.com",
  projectId: "milan-kalyan-results",
  storageBucket: "milan-kalyan-results.firebasestorage.app",
  messagingSenderId: "923764467914",
  appId: "1:923764467914:web:815d0eceeda0df02f86c33",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const firebaseAuth = getAuth(firebaseApp);
export default firebaseAuth;
